export interface CapabilityStep {
  label: string
  detail?: string
}

/** The handling loop, kept as a restrained horizontal strip. */
export const capabilitySteps: CapabilityStep[] = [
  { label: 'Answer', detail: 'Talk to the caller' },
  { label: 'Understand', detail: 'Identify intent' },
  { label: 'Act', detail: 'Handle requests' },
  { label: 'Escalate', detail: 'When needed' },
  { label: 'Remember', detail: 'Build context' },
]
